import React, { useState, useEffect } from "react";

const MessageRedirect = (props) => {
  const code = props.item && props.item.code;
  const url = props.item.url;
  const data = props.item && props.item.text_data;

  const [clicked, setClicked] = useState(false);

  let parsedItemData = null;
  try {
    parsedItemData = props?.item?.text_data || null
  } catch {
    // ignore
  }
  const isAutoRedirect = parsedItemData?.flow === "AutoRedirect";

  const [redirecting, setRedirecting] = useState(false);

  if (redirecting) {
    return (
      <div className="auto-redirect-loader">
        <div className="auto-redirect-spinner"></div>
        <p className="auto-redirect-text">Redirecting you to Binge App...</p>
      </div>
    );
 }


  const isTelLink = data?.data?.trim?.() === "caller";

  // Function to extract href value from anchor string
  const extractHref = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const anchor = doc.querySelector("a");
    return anchor ? anchor.getAttribute("href") : "";
  };

  const href = extractHref(url); // e.g., "tel:080-61999999"

  return props?.isFallback && props?.item?.text === "Chat with Agent" ? (
    <>
      <button
        className={"chat-label-fallback action-tab"}
        id="main-tab1"
        style={{
          color: "white",
          pointerEvents: clicked && "none",
          opacity: clicked && "0.5",
        }}
        onClick={() => {
          if (!props.disable) {
            props.handleClick(code);
            props.setTextOnClick(props.item.text);
            setClicked(true);
          }
          window.open(props.item.url);
        }}
      >
        {props?.item?.text}
      </button>
    </>
  ) : (
    <span
      className={
        !props.disable
          ? "chat-label action-tab "
          : "chat-labelnohover action-tab"
      }
      id="main-tab1"
    >
      {data && data.data ? (
        <form
          target="targetWindow"
          action={!props.disable && url}
          method="POST"
        >
          <input
            type="hidden"
            name={Object.keys(data.data)[0]}
            value={data.data[Object.keys(data.data)[0]]}
          ></input>
          <input
            type="submit"
            value={props.item.text}
            onClick={() => {
              if (!props.disable) {
                props.handleClick(code);
                props.setTextOnClick(props.item.text);
              }
            }}
            style={{
              color: props.disable ? "grey" : "inherit",
              border: "none",
              background: "none",
              fontFamily: "VoltePlay-Medium, sans-serif",
              fontSize: "15px",
            }}
          ></input>
        </form>
      ) : data && data !== "undefined" && !isTelLink && !isAutoRedirect ? (
        <form target="_blank" action={!props.disable && url} method="POST">
          <input
            type="hidden"
            name={Object.keys(data)[0]}
            value={data[Object.keys(data)[0]]}
          ></input>
          <input
            type="submit"
            value={props.item.text}
            onClick={() => {
              if (!props.disable) {
                props.handleClick(code);
                props.setTextOnClick(props.item.text);
              }
            }}
            style={{
              fontFamily: "VoltePlay-Medium, sans-serif",
              fontSize: "15px",
              color: props.disable ? "grey" : "inherit",
              border: "none",
              background: "none",
            }}
          ></input>
        </form>
      ) : (
        <span
          onClick={() => {
            if (isAutoRedirect) {
              setRedirecting(true);
              setTimeout(() => {
                if (!props.disable) {
                  props.handleClick(code);
                  props.setTextOnClick(props.item.text);
                }
                setRedirecting(false);
                window.open(props.item.url, "_blank");
              }, 3000);
            } else {
              if (!props.disable) {
                props.handleClick(code);
                props.setTextOnClick(props.item.text);
              }
              window.open(props.item.url);
            }
          }}
          style={{
            color: props.disable ? "grey" : "inherit",
            fontFamily: "VoltePlay-Medium, sans-serif",
            fontSize: "15px",
          }}
          target="_blank"
        >
          {props.item.text}
        </span>
      )}
    </span>
  );
};

export default MessageRedirect;
